var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 167,
    viewBox: "0 0 174 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.9559 99.5318C84.7292 99.5318 82.5938 98.6472 81.0193 97.0727C79.4448 95.4983 78.5603 93.3628 78.5603 91.1361V65.9492C78.5603 63.7225 79.4448 61.587 81.0193 60.0125C82.5938 58.438 84.7292 57.5535 86.9559 57.5535C89.1826 57.5535 91.318 58.438 92.8925 60.0125C94.467 61.587 95.3516 63.7225 95.3516 65.9492V91.1361C95.3516 93.3628 94.467 95.4983 92.8925 97.0727C91.318 98.6472 89.1826 99.5318 86.9559 99.5318ZM74.3624 120.521C74.3624 117.181 75.6892 113.978 78.051 111.616C80.4127 109.254 83.6159 107.927 86.9559 107.927C90.2959 107.927 93.4991 109.254 95.8609 111.616C98.2226 113.978 99.5494 117.181 99.5494 120.521C99.5494 123.861 98.2226 127.064 95.8609 129.426C93.4991 131.788 90.2959 133.114 86.9559 133.114C83.6159 133.114 80.4127 131.788 78.051 129.426C75.6892 127.064 74.3624 123.861 74.3624 120.521Z",
    fill: "#F4CA16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0957 8.99302C78.3925 -2.97079 95.5196 -2.97079 101.816 8.99302L171.861 142.081C177.747 153.264 169.653 166.697 157.001 166.697H16.9111C4.27562 166.697 -3.82619 153.264 2.05077 142.089L72.0957 8.99302ZM157.009 149.906L86.956 16.8094L16.9027 149.906H157.009Z",
    fill: "#F4CA16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.126f6ae3ce2a94a6e79efa43e6e47462.svg";
export { ForwardRef as ReactComponent };